import api from '@/api'
import { setFormErrors } from '@/helpers'
import { setToken, removeToken } from '@/utils/auth'


const actions = {
    searchQuery({ commit }, { params, router }) {
        commit('setLoading', true)
        api.planner.search(params)
            .then((response) => {
                if (response.data.status) {
                    commit('clearResults')
                    commit('setSearchQuery', response.data.data)
                    router.push({ name: 'Results', params: { hash: response.data.data.hash } })
                }
            })
            .catch((error) => {
                commit('setLoading', false)
                if (!setFormErrors(error.response.data.errors, commit)) {
                    commit('setDefaultError', error.response.data.message)
                }
            })
    },
    updateReturnTime({ commit }, { hash, params, router }) {
        commit('setLoading', true)
        api.planner.updateReturnTime(hash, params)
            .then((response) => {
                if (response.data.status) {
                    commit('setSearchQuery', response.data.data)
                    router.push({ name: 'Results', params: { hash: response.data.data.hash } })
                }
            })
            .catch((error) => {
                setFormErrors(error.response.data.errors, commit)
            }).then(() => {
                commit('setLoading', false)
            })
    },
    retrieveResults({ commit }, hash) {
        commit('setLoading', true)
        api.planner.getJourneys(hash)
            .then((response) => {
                commit('clearResults')
                if (response.data.data.journeys.length) {
                    response.data.data.journeys.forEach((item) => {
                        commit('addToResults', { showPlaceholder: false, journey: item })
                    })
                }
                commit('setSearchQuery', response.data.data)
            })
            .catch((error) => {
                console.log(error.response)
            })
            .then(() => {
                commit('setLoading', false)
            })
    },
    retrieveSingleJourney({ commit, state }, { hash, journeyID, showCurrentJourney = false }) {
        if (!state.currentJourney) {
            commit('setLoading', true)
        }
        api.planner.getSingleJourney(hash, journeyID)
            .then((response) => {
                const item = response.data.data
                commit('addToResults', { showPlaceholder: false, journey: item })
                if (!state.currentJourney || showCurrentJourney) {
                    commit('setCurrentJourney', item)
                }
            })
            .catch((error) => {
                console.log(error.response)
            })
            .then(() => {
                commit('setLoading', false)
            })
    },
    registerUser({ commit }, { params, router }) {
        commit('setLoading', true)
        api.users.register(params)
            .then((response) => {
                if (response.data.status) {
                    commit('setDefaultSuccess', response.data.data.message)
                    router.push({ name: 'Home' })
                }
            })
            .catch((error) => {
                if (!setFormErrors(error.response.data.errors, commit)) {
                    commit('setDefaultError', error.response.data.message)
                }
            })
            .then(() => {
                commit('setLoading', false)
            })
    },
    updateUser({ commit }, { params, router }) {
        commit('setLoading', true)
        api.users.update(params)
            .then((response) => {
                commit('setUserInfo', response.data.data)
                commit('setDefaultSuccess', 'Account successfully updated')
                router.push({ name: 'Account' })
            }).catch((error) => {
                console.log(error)
                if (!setFormErrors(error.response.data.errors, commit)) {
                    commit('setDefaultError', error.response.data.message)
                }
            }).then(() => {
                commit('setLoading', false)
            })
    },
    loginUser({ commit, dispatch }, { params, router }) {
        commit('setLoading', true)
        api.auth.login(params)
            .then((response) => {
                /* set Token in cookies */
                setToken(response.data.data.access_token)
                /* commit Tokne to store */
                commit('setUserToken', response.data.data.access_token)
                commit('setDefaultSuccess', 'Successfully logged in')
                dispatch('fetchAuthenticatedUser')
                router.push({ name: 'Home' })
            })
            .catch((error) => {
                if (!setFormErrors(error.response.data.errors, commit)) {
                    commit('setDefaultError', error.response.data.message)
                }
            })
            .then(() => {
                commit('setLoading', false)
            })
    },
    activateUser({ commit }, { params }) {
        commit('setLoading', true)
        api.users.activate(params.code)
            .then((response) => {
                if (response.data.status) {
                    commit('setDefaultSuccess', response.data.data.message)
                }
            })
            .catch((error) => {
                if (!setFormErrors(error.response.data.errors, commit)) {
                    commit('setDefaultError', error.response.data.message)
                }
            })
            .then(() => {
                commit('setLoading', false)
            })
    },
    passwordReset({ commit }, { params }) {
        commit('setLoading', true)
        api.users.passwordReset(params)
            .then((response) => {
                if (response.data.status) {
                    commit('setDefaultSuccess', response.data.data.message)
                }
            })
            .catch((error) => {
                if (!setFormErrors(error.response.data.errors, commit)) {
                    commit('setDefaultError', error.response.data.message)
                }
            })
            .then(() => {
                commit('setLoading', false)
            })
    },
    changePassword({ commit }, { params, router }) {
        commit('setLoading', true)
        api.users.changePasswordRequest(params)
            .then((response) => {
                if (response.data.status) {
                    commit('setDefaultSuccess', response.data.data.message)
                    router.push({ name: 'Login' })
                }
            })
            .catch((error) => {
                if (!setFormErrors(error.response.data.errors, commit)) {
                    commit('setDefaultError', error.response.data.message)
                }
            })
            .then(() => {
                commit('setLoading', false)
            })
    },
    saveJourneyRequest({ commit }, journeyID) {
        commit('setLoading', true)
        api.journey.saveJourney(journeyID)
            .then((response) => {
                if (response.data.status) {
                    commit('setDefaultSuccess', 'Journey saved')
                    commit('markCurrentJourneySaved')
                }
            }).catch((e) => {
                console.log(e)
            }).then(() => {
                commit('setLoading', false)
            })
    },
    getUser({ commit, response }) {
        commit('USER_INFO', response)
    },
    fetchAuthenticatedUser({ commit }) {
        api.users.fetchAuthenticatedUser()
            .then((response) => {
                commit('setUserInfo', response.data.data)
            }).catch(() => {
                commit('setUserToken', null)
                removeToken()
            })
    },
    getRecentJourneysForUser({ commit }, { params }) {
        api.users.usersRecentJourneys(params)
            .then((response) => {
                commit('userRecentJourneys', response.data.data)
                commit('recentJourneysMeta', response.data.meta)
            })
    },
    getSavedJourneysForUser({ commit }, { params }) {
        api.users.usersSavedJourneys(params)
            .then((response) => {
                commit('userSavedJourneys', response.data.data)
                commit('savedJourneysMeta', response.data.meta)
            })
    },

    getActiveCampaign({ commit }, { params }) {
        api.campaigns.getActiveCampaign(params)
            .then((response) => {
                if (response.data.data.length === 1) {
                    commit('activeCampaign', response.data.data[0])
                }
            });
    },
    recordCampaignImpression({ commit }, { params }) {
        api.campaigns.recordCampaignImpression(params)
            .then((response) => {
                if (response.data.data) {
                    commit('addCampaignImpression', response.data.data)
                }
            });
    },
    resetActiveCampaignAndImpression({ commit }) {
        commit('resetActiveCampaignAndImpression')
    },
}

export default actions
